import { map } from "lodash";
import { emit } from "skatejs";
import { HTMLElementClass } from "skatejs/types";
import { logFeatureUsage } from "./userpreference.log";

export const saveUserPreferences = (
  widget: EventTarget | HTMLElementClass,
  eventNameList: string[],
  value: any
) => {
  if (eventNameList && eventNameList.length) {
    map(eventNameList, event => {
      logFeatureUsage(event);
      emit(widget, event, {
        detail: value,
      });
    });
  }
};
